<template>
    <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" v-model="dataInicial">
                </div>
                <div class="col-md-6">
                    <input type="date" v-model="dataFinal">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getTeoricasRejeitadas()" class="btn btn-dark btn-micro">Gerar Planilha</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import RelatoriosController from '../RelatoriosController'

export default {
    name: 'TeoricasRejeitadas',
    components: {
        ...spinners,
    },

    data () {
        return {
            download: {
                load: false
            },
            dataInicial: '',
            dataFinal: ''
        }
    },

    methods: {

        getTeoricasRejeitadas()
        {
            this.download.load = true
            var data = {
                dataInicial: this.dataInicial,
                dataFinal: this.dataFinal
            }
            if(this.dataInicial === '' || this.dataFinal === '') {
                this.launchToast('fa-warning', 'Por favor, informe o período!')
                this.download.load = false
            } else {
                RelatoriosController.getTeoricasRejeitadas(data, (response) => {
                    if(response.sucesso === false) {
                        this.download.load = false
                    } else {
                        var csv = 'data:text/csv;charset=utf-8,' + response.dados;
                        var dlnk = document.getElementById('downloadCSV');
                        dlnk.download="teoricas-rejeitadas.csv";
                        dlnk.href = csv;
                        dlnk.click();
                        this.download.load = false
                    }
                })
            }
        },

        launchToast(icon, msg)
        {
            this.$toasted.show(msg, {
                position: 'top-right',
                icon: icon
            });
        }

    }
}
</script>